import { render, staticRenderFns } from "./AddTicket.vue?vue&type=template&id=73e24d0b"
import script from "./AddTicket.vue?vue&type=script&lang=js"
export * from "./AddTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports